import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { GoogleMapUrl, Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import numeral from 'numeral';
import { colors } from '../../styles';
import DetailHeaderWrapper from '../../components/DetailHeaderWrapper';
import ContactModal from '../../components/ContactModal';
// import SitePlanModal from './Map';

const styles = css`
  width: 100%;
  flex-direction: column;
  padding-top: 70px;
  @media(min-width: 992px) {
    display: flex;
    height: 800px;
    flex-direction: row;
    padding-top: 100px; /* for header area */
  }
  .DetailHeader_imageWrapper {
    width: 100%;
    height: 33vh;
    @media(min-width: 992px) {
      order: 1;
      flex: 1;
      height: 100%;
    }
  }
  .DetailHeader_contentWrapper {
    background-color: ${colors.neutral};
    @media(min-width: 992px) {
      width: 33.333vw;
      padding: 0 0 0 0; /* for descending logo */
    }
  }
  .DetailHeader_heading {
    background-color: ${colors.neutralDark};
    font-weight: 700;
    font-size: 20px;
    color: ${colors.brand1};
    margin: 0;
    padding: 20px 15px;
    line-height: 18px;
    @media(min-width: 992px) {
      font-size: 26px;
      padding: 20px 50px;
    }
    span {
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.5px;
      color: ${colors.body};
    }
  }
  .DetailHeader_price {
    background-color: ${colors.white};
    margin: 0;
    font-weight: 700;
    font-size: 24px;
    letter-spacing: 0.5px;
    padding: 5px 15px 10px 15px;
    color: ${colors.body};
    @media(min-width: 992px) {
      padding: 5px 10px 10px 50px;
    }
    span {
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.5px;
    }
  }
  .DetailHeader_detailsList {
    padding: 0 15px;
    list-style: none;
    margin: 20px 0 30px 0;
    @media(min-width: 992px) {
      padding: 0 50px;
    }
  }
  .DetailHeader_detailsListItem {
    font-size: 16px;
    line-height: 1.2;
    text-align: left;
    color: ${colors.body};
    font-weight: 300;
    margin: 0 0 6px 0;
  }
  .DetailHeader_button {
    background-color: ${colors.brand1};
    padding: 0 10px 0 70px;
    color: ${colors.white};
    font-weight: 400;
    position: relative;
    line-height: 60px;
    display: inline-block;
    margin: 0 0 20px 15px;
    transition: all .3s ease;
    cursor: pointer;
    font-size: 15px;
    &:hover {
      background-color: ${colors.brand1Lighter};
    }
    @media(min-width: 992px) {
      margin: 0 0 20px 50px;
    }
  }
  .DetailHeader_buttonImage {
    position: absolute;
    width: 60px;
    height: 60px;
    left: 0;
    top: 0;
    object-fit: cover;
  }
  .DetailHeader_headline {
    text-align: center;
    background-color: rgba(0, 0, 0, 0.85);
    color: ${colors.white};
    width: 100%;
    text-transform: uppercase;
    font-size: 27px;
    letter-spacing: 1px;
    font-weight: 700;
    text-shadow: rgba(0, 0, 0, 0.89) 1px 1px;
    padding: 10px 20px;
    position: absolute;
    z-index: 2;
    left: 0;
    bottom: 0;
  }

`;

function CommunityHeader({ builder, community, agent }) {
  return (
    <div className={styles}>
      <DetailHeaderWrapper imageUrl={get(community, 'photos[0].contentUrl')} className="DetailHeader_imageWrapper">
        {
          get(community, 'headline') &&
          <div className="DetailHeadline_wrapper">
            {get(community, 'headline')}
          </div>
        }
      </DetailHeaderWrapper>
      <div className="DetailHeader_contentWrapper">
        <h1 className="DetailHeader_heading">
          {get(community, 'name')}<br />
          <span>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</span>
        </h1>
        {
          get(community, 'priceLow') &&
          <h3 className="DetailHeader_price">
            <span>Starting At</span><br />
            {numeral(get(community, 'priceLow')).format('$0,0')}
          </h3>
        }
        <ul className="DetailHeader_detailsList">
          <li className="DetailHeader_detailsListItem">
            <strong>Model Home</strong><br />
            {get(community, 'address.streetAddress')}<br />
            {get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}<br />
            <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
              <strong>Get Directions</strong>
            </a>
          </li>

          {/* {
            get(community, 'priceLow') &&
            <li className="DetailHeader_detailsListItem">
              <strong>Price Range: </strong>{numeral(get(community, 'priceLow'))
              .format('$0,0')} - {numeral(get(community, 'priceHigh')).format('$0,0')}
            </li>
          } */}
          {
            get(community, 'sqftLow') &&
            <li className="DetailHeader_detailsListItem">
              <strong>SQFT Range: </strong>{numeral(get(community, 'sqftLow')).format('0,0')}{get(community, 'sqftHigh') > 0 ? ` - ${numeral(get(community, 'sqftHigh')).format('0,0')}` : '+'}
            </li>
          }
          <li className="DetailHeader_detailsListItem">
            <strong>Status: </strong>{get(community, 'status')}
          </li>
          {
            get(community, 'community_hours') &&
            <li className="DetailHeader_detailsListItem">
              <strong>Hours: </strong>{get(community, 'community_hours')}
            </li>
          }
        </ul>
        <ContactModal builder={builder} formName="contactUsModalCommunity">
          <div className="DetailHeader_button">
            <Image
              src={get(agent, 'logo.contentUrl')}
              alt="Community Agent"
              className="DetailHeader_buttonImage"
              width={100}
              height={100}
            />
            Schedule A Showing
          </div>
        </ContactModal>
      </div>
    </div>
  );
}

CommunityHeader.propTypes = {
  builder: PropTypes.object.isRequired,
  community: PropTypes.object.isRequired,
  agent: PropTypes.object,
};

CommunityHeader.defaultProps = {
  agent: undefined,
};

export default withData(
  {
    builder: true,
    community: true,
    homes: true,
    agent: true,
  },
  {
    required: {
      community: true,
    },
  },
)(CommunityHeader);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityHeader.js